import {Component, Input, OnInit} from '@angular/core';
import {OwlOptions} from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-four-pane-gallery',
  templateUrl: './four-pane-gallery.component.html',
  styleUrls: ['./four-pane-gallery.component.scss']
})
export class FourPaneGalleryComponent implements OnInit {

    @Input() items: [
        {
            image: string;
            tag: string;
            title: string;
            subtitle: string;
            description: string;
            callback: Function;
        },
    ];

    customOptions: OwlOptions = {
        autoplay: false,
        loop: false,
        mouseDrag: false,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        navText: ['', ''],
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            740: {
                items: 1,
            },
            940: {
                items: 4,
            },
        },
        nav: false,
    };

    constructor() {}

    ngOnInit(): void {}

}
